import React from 'react'
import translations from './translations'

translations.add('en', {
    iAgreeToShareWithClickToPay: (cardBrand) => <span>
        I agree to share my card details, billing address and email with {cardBrand || 'Mastercard'} to allow me to securely enroll in <b>Click to Pay</b> for faster checkouts.
    </span>,
    learnMore: 'Learn more'
})
